import platformAdmin from './platformAdmin';
import table from './table';
import common from './common';
import help from './help';
import navigation from './navigation';
import dashboard from './dashboard';
import documents from './documents';
import time from './time';
import auth from './auth';
import errors from './errors';
import success from './success';
import confirmation from './confirmation';
import notifications from './notifications';
import session from './session';
import pagination from './pagination';
import upload from './upload';
import testUpload from './testUpload';
import search from './search';
import permissions from './permissions';
import metadata from './metadata';
import departments from './departments';
import admin from './admin';
import settings from './settings';
import audit from './audit';
import anomalies from './anomalies';
import cad from './cad';
import drbfm from './drbfm';
import verification from './verification';
import profile from './profile';
import chat from './chat';
import validation from './validation';
import evidence from './evidence';

const jaTranslations = {
  platformAdmin,
  table,
  common,
  help,
  navigation,
  dashboard,
  documents,
  time,
  auth,
  errors,
  success,
  confirmation,
  notifications,
  session,
  pagination,
  upload,
  testUpload,
  search,
  permissions,
  metadata,
  departments,
  admin,
  settings,
  audit,
  anomalies,
  cad,
  drbfm,
  verification,
  profile,
  chat,
  validation,
  evidence,
};

export default jaTranslations;
